import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { Loadable } from '../base/components/Lodable'

const ClienteListadoApp = Loadable(lazy(() => import('./view/ClienteGestion')))

/**
 * Mapa de rutas
 */
export const clienteRoutesMap = {
  gestionCliente: {
    path: '/cliente/gestion',
    name: 'Clientes',
    actionSecure: 'ADMINISTRAR',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const clienteRoutes = [
  {
    path: clienteRoutesMap.gestionCliente.path,
    element: <ClienteListadoApp />,
    auth: authRoles.admin,
  },
]

export default clienteRoutes
